import { SecurityAnalysisTexts } from 'constants/enums/trucker';
import { textConstants } from 'constants/texts';
import { useAmplitude } from 'hooks/useAmplitude';
import { useSendTracking } from 'hooks/useSendTracking';
import { useTruckerProps } from 'hooks/useTruckerProps';
import { ITruckerProfileProps } from 'interfaces/profile.interface';
import React from 'react';
import { TSecurityAnalysisEventName } from './types';

const useSecurityAnalysisEvents = () => {
  const { eventsSource, freightId } = useTruckerProps();

  const { sendAmplitude } = useAmplitude();
  const { sendTrackingJaiminho } = useSendTracking();

  const getTagEvent = (tag: keyof typeof SecurityAnalysisTexts): string => SecurityAnalysisTexts[tag];

  const emmitEvents = (
    eventName: TSecurityAnalysisEventName,
    truckerData: ITruckerProfileProps,
    tag: keyof typeof SecurityAnalysisTexts,
    event?: React.MouseEvent
  ) => {
    const {
      trucker: { id: truckerId, uuid },
    } = truckerData;

    sendAmplitude(eventName, {
      freightId: freightId || textConstants.notAvailaible,
      truckerId,
      source: eventsSource,
      tag: getTagEvent(tag),
    });

    sendTrackingJaiminho(
      {
        nameEvent: eventName,
        clickEvent: event,
        data: {
          freight_id: freightId ? `hashed|${freightId}` : textConstants.notAvailaible,
          person_id: `hashed|${truckerId}`,
          person_uuid: uuid,
          source: eventsSource,
          tag: getTagEvent(tag),
        },
      },
      'events'
    );
  };

  return { emmitEvents };
};

export default useSecurityAnalysisEvents;
